<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="35rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon text small v-on="on">
        <v-icon small>fa-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text v-if="recipe !== undefined">
        <v-form ref="form" v-model="valid" @submit.prevent="submit">
          <v-row align="center" class="mt-3" dense>
            <v-col cols="6">
              <j-decimal-input
                :disabled="loading"
                :hide-details="$vuetify.breakpoint.xsOnly"
                filled
                dense
                class="no-before"
                v-model="recipe.data.quantity_inventory"
                label="Quantité d'inventaire"
                read-only
                :min="0.0001"
                :required="getUseConversionFormulaModel === true"
              ></j-decimal-input>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :disabled="loading"
                :hide-details="$vuetify.breakpoint.xsOnly"
                filled
                dense
                class="no-before"
                v-model="recipe.data.unite_inventory"
                :rules="[
                  v => v !== null || 'Une unité de mesure est nécessaire',
                  v => v !== undefined || 'Une unité de mesure est nécessaire'
                ]"
                :items="getAllowedUnits"
                label="Unité de mesure pour l'inventaire"
                :required="getUseConversionFormulaModel === true"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center" dense>
            <v-col cols="3">
              <span class="subtitle-1">équivaut à</span>
            </v-col>
            <v-col cols="6">
              <j-decimal-input
                :disabled="loading"
                :hide-details="$vuetify.breakpoint.xsOnly"
                filled
                dense
                class="no-before"
                v-model="recipe.data.quantity_production"
                label="Quantité de production"
                read-only
                :required="getUseConversionFormulaModel === true"
                :min="0.0001"
                :suffix="recipe.unite_produite"
              ></j-decimal-input>
            </v-col>
            <v-col cols="3" style="text-align: end;">
              <span class="subtitle-1">en inventaire</span>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters dense>
            <v-text-field
              :disabled="loading"
              dense
              filled
              class="no-before"
              hide-details="auto"
              v-model="recipe.data.comments_inventory"
              label="Détails additionnels sur la prise d'inventaire"
            ></v-text-field>
          </v-row>
        </v-form>
        <v-row v-show="loading" no-gutters class="mt-3">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row align="center" justify="center" no-gutters>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" dense no-gutters>
          <v-btn
            :disabled="
              valid === false || recipe === undefined || loading === true
            "
            small
            color="success"
            @click="submit"
          >
            Enregistrer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "RecipeInventoryEditorDialog",
  props: {
    recipeId: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits"]),
    getUseConversionFormulaModel: {
      get() {
        return this.recipe.data.use_conversion_formula;
      },
      set(v) {
        this.recipe.data.use_conversion_formula = v;
        if (v === false) {
          this.recipe.data.quantity_production = null;
        }
      }
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      recipe: undefined,
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.recipe = await api.retrieveRecipe(this.recipeId);
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      try {
        if (this.valid === true) {
          this.loading = true;
          await api.patchRecipe(this.recipeId, this.recipe);
          this.$store.dispatch("loadRecipes");
          this.dialog = false;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.getData();
      } else {
        this.recipe === undefined;
      }
    }
  }
};
</script>

<style></style>
